import { customEventListener } from '@helpers/customEventListener.js';

(() => {

	customEventListener('#cookieWarningForm [name="OptInLevel"]', 'change', res => {
		const categories = document.querySelectorAll('.cookie-warning__categories');
		if(categories) {
			categories.forEach(category => {
				if(res.target.value == 1) {
					category.classList.remove('cookie-warning__categories--hidden');
				} else {
					resetCheckboxes();
					category.classList.add('cookie-warning__categories--hidden');
				}
			});
		}
	});

	customEventListener('#cookieWarningForm', 'submit', e => {
		e.preventDefault();

		const cookieModal = document.getElementById('cookieWarningContainer');
		const formElement = document.getElementById('cookieWarningForm');
		const formData = new FormData(formElement);
		let xmlhttp;
		if (window.XMLHttpRequest) {
			xmlhttp = new XMLHttpRequest();
		} else {
			xmlhttp = new ActiveXObject('Microsoft.XMLHTTP');
		}

		xmlhttp.onreadystatechange = function () {
			if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
				cookieModal.remove();
				return false;
			}
		};
		xmlhttp.open(formElement.method, formElement.action);
		xmlhttp.send(formData);

		return false;
	});

	const resetCheckboxes = () => {
		const checkboxes = [...document.querySelectorAll('[name="OptInCategory"]')];
		checkboxes.forEach(checkbox => {
			checkbox.checked = false;
		});
	};

})();